import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import './ModalContainer.scss';
import Divider from '@material-ui/core/Divider';

export const extendWithModalSupport = instance => {
    instance.modalRef = React.createRef();

    Object.defineProperty(instance, 'modalInstance', {
        get: () => (instance.modalRef && instance.modalRef.current) || {}
    });
};

export class ModalContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openModal: false
        };
    }

    openModal = () => {
        this.setState({
            ...this.state,
            openModal: true
        });
    };

    closeModal = () => {
        this.setState({
            ...this.state,
            openModal: false
        });
    };

    render() {
        const { title, content } = this.props;

        return (
            <Modal
                className={'modal-container'}
                open={this.state.openModal}
                onClose={() => this.closeModal()}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                    className: 'backdrop'
                }}
            >
                <Fade in={this.state.openModal}>
                    <div className={'modal-content'}>
                        <div className={'modal-header'}>
                            <span>{title}</span>
                            <i
                                className={'material-icons'}
                                onClick={() => this.closeModal()}
                            >
                                close
                            </i>
                        </div>
                        <Divider className={'modal-divider'} />
                        <div className={'modal-body'}>{content}</div>
                    </div>
                </Fade>
            </Modal>
        );
    }
}
